import { useEffect } from 'react';

import { PROXY_HANDSHAKE_TIMEOUT_MS } from '../constants';

interface UseProxyIntegrationEffectsProps {
  frameKey: string;
  isFrameEnabled: boolean;
  onResetHandshake: () => void;
  isHandshakePending: boolean;
  onHandshakeTimeout: () => void;
}

export const useProxyIntegrationEffects = ({
  frameKey,
  isFrameEnabled,
  onResetHandshake,
  isHandshakePending,
  onHandshakeTimeout,
}: UseProxyIntegrationEffectsProps) => {
  useEffect(() => {
    onResetHandshake();
  }, [frameKey, isFrameEnabled, onResetHandshake]);

  useEffect(() => {
    if (!isHandshakePending) return;

    const timerId = window.setTimeout(
      onHandshakeTimeout,
      PROXY_HANDSHAKE_TIMEOUT_MS
    );

    return () => {
      window.clearTimeout(timerId);
    };
  }, [isHandshakePending, onHandshakeTimeout]);
};
